import { useMemo } from 'react';
import { useAlgo } from './useAlgo';
import { useUserAssetsQuery } from './useUserAssetsStore';

const useTokenBalance = (tokenId) => {
  const { address } = useAlgo();
  const assetsQuery = useUserAssetsQuery({ address });
  const assets = assetsQuery.data || [];

  const balance = useMemo(() => {
    const tokenTotal = assets.find((asset) => asset['asset-id'] === tokenId);
    return tokenTotal?.amount || 0;
  }, [assets]);

  return balance;
};

export default useTokenBalance;
